interface EpisodeMeta {
  meta_name: string;
  meta_value: string;
}

export const mapEpisodeDetails = (
  metaArray: EpisodeMeta[],
): Record<string, string> => {
  if (Array.isArray(metaArray)) {
    return metaArray.reduce<Record<string, string>>((acc, cur) => {
      const key = cur.meta_name.trim();
      const value = cur.meta_value.trim();
      acc[key] = value;
      return acc;
    }, {});
  }

  return {};
};

export const mapEpisodeValueToMeta = (
  metaValues: Record<string, string>,
): EpisodeMeta[] => {
  if (metaValues && typeof metaValues === 'object') {
    return Object.entries(metaValues)
      .filter(([key, value]) => typeof value === 'string') // Filter out non-string values
      .map(([key, value]) => ({
        meta_name: key.trim(),
        meta_value: value.trim(),
      }));
  }

  return [];
};
